import React, { useEffect, useState } from 'react'
import { Button, Icon, Message } from 'semantic-ui-react'
import ActorDetailHeader from './actorDetailHeader'
import { Accordion, AccordionItem } from '@commonComponents/accordion'
import RepeatableMerchandiseContainer from '@containers/repeatableMerchandiseContainer'
import { useMultipleMerchandiseParties } from '@EUForms/hooks/useMultipleMerchandiseParties'
import ActorDetails from './actors/ActorDetails'
import AddtionalSupplyChainDetail from '../../parties/addtionalSupplyChainDetail'
import AuthorizationDetail from '../../parties/authorizationDetail'
import useValidatePartiesAtMerchandise from '../../../hooks/useValidatePartiesAtMerchandise'

const MERCH_PARTIES_LABEL = {
    CONSIGNEE: 'consigneeList',
    CONSIGNOR: 'consignorsList',
    AUTHORIZATION: 'authorizationsList',
    ADD_SUP_CHAIN_ACTOR: 'additionalSupplyChainActorsList',
}

const buttonStyle = {
    backgroundColor: '#FFFFFF',
    textTransform: 'uppercase',
}

const MerchandiseParties = ({ translate, invoiceId, merchandiseId, invoiceIndex, itemIndex }) => {
    const [isActive, setIsActive] = useState(false)
    const { ...rest } = useMultipleMerchandiseParties({ invoiceId, merchandiseId, containerKey: 'merchandiseParties' })
    const {maxAllowedConsigneeList, maxAllowedConsignorsList} = useValidatePartiesAtMerchandise()
    return (
        <Message style={{ padding: '5px 5px' }}>
            <Button fluid
                style={buttonStyle}
                id={`expandCollapseParties-${invoiceId}-${merchandiseId}`}
                onClick={() => setIsActive(preState => !preState)}>
                <div>
                    <Icon name={`${isActive ? 'minus' : 'plus'} circle`} />
                    <strong>{translate("PARTIES")}</strong>
                </div>
            </Button>
            {isActive && (
                <div>
                    <Accordion initialiState={{consigneeList:true,consignorsList:true}} translate={translate}>
                        <AccordionItem id="consigneeList" title={(props) => (
                            <ActorDetailHeader
                                translate={translate}
                                {...props}
                                title={'CONSIGNEE'}
                                containerKey='merchandiseParties'                                 
                                merchandiseId={merchandiseId}
                                tableName='consigneeList'
                            />)}>
                            <RepeatableMerchandiseContainer
                                reducerName='invoiceReducer'
                                containerKey='merchandiseParties'
                                tableName={MERCH_PARTIES_LABEL.CONSIGNEE}
                                invoiceId={invoiceId}
                                merchandiseId={merchandiseId}
                                title=''
                                maxRowsAllowed={maxAllowedConsigneeList}
                                translate={translate}
                                renderForm={(params) => <ActorDetails {...params} />}
                                {...rest}
                            />
                        </AccordionItem>
                        <AccordionItem id="consignorsList" title={(props) => (
                            <ActorDetailHeader
                                translate={translate}
                                {...props}
                                title={'CONSIGNOR'}
                                merchandiseId={merchandiseId}
                                tableName='consignorsList'
                            />)}>
                            <RepeatableMerchandiseContainer
                                reducerName='invoiceReducer'
                                containerKey='merchandiseParties'
                                tableName={MERCH_PARTIES_LABEL.CONSIGNOR}
                                invoiceId={invoiceId}
                                merchandiseId={merchandiseId}
                                title=''
                                maxRowsAllowed={maxAllowedConsignorsList}
                                translate={translate}
                                renderForm={(params) => <ActorDetails {...params} />}
                                {...rest}
                            />
                        </AccordionItem>
                    </Accordion>
                    <RepeatableMerchandiseContainer
                        reducerName='invoiceReducer'
                        containerKey='merchandiseParties'
                        tableName={MERCH_PARTIES_LABEL.ADD_SUP_CHAIN_ACTOR}
                        invoiceId={invoiceId}
                        merchandiseId={merchandiseId}
                        title="ADD_SUPPLY_CHAIN_ACTOR"
                        maxRowsAllowed={4}
                        translate={translate}
                        renderForm={(params) => <AddtionalSupplyChainDetail 
                            isItemsTab={true}
                            invoiceId={invoiceId}
                            merchandiseId={merchandiseId}
                            invoiceIndex={invoiceIndex}
                            itemIndex={itemIndex}
                            {...params} 
                        />}
                        {...rest}
                    />
                    <RepeatableMerchandiseContainer
                        reducerName='invoiceReducer'
                        containerKey='merchandiseParties'
                        tableName={MERCH_PARTIES_LABEL.AUTHORIZATION}
                        invoiceId={invoiceId}
                        merchandiseId={merchandiseId}
                        title="AUTHORIZATION"
                        maxRowsAllowed={2}
                        translate={translate}
                        renderForm={(params) => <AuthorizationDetail 
                            isItemsTab={true}
                            invoiceId={invoiceId}
                            merchandiseId={merchandiseId}
                            invoiceIndex={invoiceIndex}
                            itemIndex={itemIndex}
                            {...params} 
                        />}
                        {...rest}
                    />
                </div>
            )}
        </Message>
    )
}

export default MerchandiseParties